import React, { useEffect, useState } from "react";
import styles from "../index.module.css"
import SolicitationService from "../../../../services/SolicitationService/SolicitationService"
import SolicitationAttendantService from "../../../../services/SolicitationAttendantService/SolicitationAttendantService";
import LcAccordion from "../../../../components/Generic/LcAccordion";
import { SolicitationView } from "../../../../models/SolicitationView";
import moment from "moment";
import Parse from "html-react-parser";
import TextTools from "../../../../services/TextTools/TextTools";
import LcIcon from "../../../../components/Generic/LcIcon";
import Modal from "../../../../components/Dialog/Modal";
import LCFlexContainer from "../../../../components/Layout/LCFlexContainer";
import LCFlexItem from "../../../../components/Layout/LCFlexItem";

interface Props {
    solicitation: SolicitationView,
}

const SolicitationInformationDetails: React.FC<Props> = (props) => {
    const solicitationService = new SolicitationService(props);
    const solicitationAttendantService = new SolicitationAttendantService(props);
    const [status, setStatus] = useState<tiposWork>({ id: 0, label: "", icon: "" });
    const [workStatus, setWorkStatus] = useState<tiposWork>({ id: 0, label: "", icon: "" })
    const [urgency, setUrgency] = useState<tipos>({ value: 0, label: "" });
    const [colorUrgency, setColorUrgency] = useState<string>("");
    const textTools = new TextTools();
    const [solicitacaoPai, setSolicitacaoPai] = useState<number>(0);
    const [modalOpen, setModalOpen] = useState(false);
    const [details, setDetails] = useState<any>("");
    const [enableDetailsButton, setEnableDetailsButton] = useState<boolean>(false);

    type tipos = { value: number | string, label: string; }
    type tiposWork = { id: number, label: string; icon: string | undefined }

    useEffect(() => {
        if (props.solicitation) {
            getServices();
            setDetails(parseDetails((props.solicitation.details)) ?? "");
            setEnableDetailsButton(textTools.cleanAllTags(props.solicitation.details).length > 2000);
        }
        else {
            setDetails("detalhes");
        }
    }, [props.solicitation])

    const getServices = () => {
        let status = solicitationService.statusList.find(x => x.value === props.solicitation.idStatus.toString());
        let statusIcon = solicitationService.workStatus.find(x => x.id === props.solicitation.idStatus)?.icon;

        statusIcon = (statusIcon === undefined && props.solicitation.statusIcon) ? props.solicitation.statusIcon : statusIcon
        let workStatus = solicitationService.workStatus.find(x => x.id === props.solicitation.workStatus);

        // let status = solicitationService.workStatus.find(x => x.id === props.solicitation.workStatus);
        status && statusIcon && setStatus({ id: parseInt(status.value), label: status.label, icon: statusIcon });
        workStatus && setWorkStatus(workStatus)

        let urgency = solicitationService.urgency.find(x => x.id === props.solicitation.urgency);
        urgency && setUrgency({ value: urgency.id, label: urgency.label });
        urgency && setColorUrgency(urgency.color);

        GetParentLinkedSolicitation();
    };

    const GetParentLinkedSolicitation = async () => {
        try {
            const solicitacaoVinculada = await solicitationAttendantService.GetLinkedSolicitationParent(props.solicitation.id);

            if (solicitacaoVinculada.data.length > 0) {
                setSolicitacaoPai(solicitacaoVinculada.data[0].idSolicitation);
            }
        }
        catch (error) {
            debugger
        }
    }

    const changeLastLetter = (str: string) => {
        if (props.solicitation.idStatus !== 13 && str.endsWith("a")) {
            return str.substring(0, str.length - 1) + "o";
        }

        return str;
    }

    const parseDetails = (text) => {
        var text_ = textTools.cleanCss(text);
        text_ = (text_.includes("<body")) ? text_.replace("<body", "<body style=\"background-color: initial;\"") : text_;
        text_ = text_.replaceAll("\r\n", "");

        const textParse = text_.includes(".com.br>") || text_.includes(".com>") || text_.includes(".br>") ? Parse(textTools.cleanOnlyEmailParse(text_)) : Parse((text_ + " "));
        var arr: any[] = [].slice.call(textParse);

        arr = (textParse instanceof Array) ? [].slice.call(textParse) : [textParse];
        let countBr = 0;

        arr = arr.filter((x, index) => {
            countBr = (arr[index].type === "br" && arr[index + 1].type && arr[index + 1].type === "br") ? countBr + 1 : 0;

            if (arr[index].type !== "br") {
                return x;
            }
            else if (countBr <= 5) {
                return x;
            }
            else {
                return x;
            }
        });

        return arr as JSX.Element[];
    }

    return (
        <div style={{ marginTop: "20px" }}>
            <LcAccordion title={"Detalhes"} visible={true} iconNormal={true}>
                <div style={{ marginTop: "35px", paddingBottom: "1rem" }}>
                    <p style={{ textAlign: "justify", width: "90%", whiteSpace: "break-spaces", maxHeight: "40vh" }} className={"datails scrollable-v scrollable-h"}>{details}</p><br /><br />
                    {
                        enableDetailsButton &&
                        <div className={"row between"} style={{ paddingBottom: "25px", paddingRight: "100px", display: "flex", justifyContent: "center" }}>
                            <button
                                className="lc-button bg-info"
                                id={"Ver Mais"}
                                onClick={() => setModalOpen(true)}
                                color="primary"
                            >
                                Ver detalhes
                            </button>
                        </div>
                    }
                    <span>Aberto em {props.solicitation ? (<b>{moment(props.solicitation.registrationDate).format("DD/MM/YYYY")}</b>) : "data"} às {props.solicitation ? (<b>{moment(props.solicitation.registrationDate).format("HH:mm")}</b>) : "hora"}</span>
                    <div style={{ display: "flex", marginTop: "30px", alignItems: "center" }}>
                        {
                            status.icon &&
                            <>
                                <LcIcon icon={status.icon} color={"grey"} />
                                <span>Chamado <b>{changeLastLetter(status.label.toLowerCase())}</b></span>
                            </>
                        }
                    </div>
                    <div style={{ display: "flex", marginBottom: "10px", marginTop: "5px", alignItems: "center" }}>
                        {
                            workStatus.icon &&
                            <>
                                <LcIcon icon={workStatus.icon} color={"grey"} />
                                <span>Trabalho <b>{changeLastLetter(workStatus.label.toLowerCase())}</b> </span>
                            </>
                        }
                    </div>
                    <div style={{ display: "flex", alignItems: "center", marginLeft: "8px" }}>
                        <div style={{
                            width: "20px",
                            height: "20px",
                            border: "10px solid",
                            borderColor: colorUrgency,
                            marginRight: "14px"
                        }} />
                        <p> Prioridade <b>{urgency.label.toLowerCase()}</b></p>
                    </div>
                    <div style={{ display: "flex", marginBottom: "10px", marginTop: "5px", alignItems: "center" }}>
                        {
                            workStatus.icon && solicitacaoPai > 0 &&
                            <>
                                <LcIcon icon={"ppi ppi-external-link"} color="grey" />
                                <span> Solicitação pai:
                                    <a href={"/Attendance/" + solicitacaoPai} style={{ textDecoration: "none" }}>
                                        <b>{" " + solicitacaoPai}</b>
                                    </a>
                                </span>
                            </>
                        }
                    </div>
                </div>
            </LcAccordion>

            <Modal
                title={"Detalhes"}
                close={() => setModalOpen(false)}
                visible={modalOpen}
                width={"80%"}>
                <p style={{ textAlign: "initial", width: "95%", maxHeight: "60vh", margin: "20px" }} className={"datails scrollable-v"}>{details}</p>
                <div className="row end">
                    <button
                        style={{ margin: "10px" }}
                        className="lc-button bg-info"
                        id={"Fechar"}
                        onClick={() => setModalOpen(false)}
                        color="primary"
                    >
                        Fechar
                    </button>
                </div>
            </Modal>
        </div>
    );
};

export default SolicitationInformationDetails;